
import { FuseNavigation } from '@fuse/types';
// let empRole = localStorage.getItem('role');
// let navbar = [];
// switch (empRole) {
//   case 'Admin':
//     navbar = [
//       // {
//       //   id: 'profile',
//       //   title: 'Profile',
//       //   type: 'item',
//       //   icon: 'person',
//       //   url: '/profile',
//       // },

//       {
//         id: 'dashboards',
//         title: 'Dashboards',
//         type: 'collapsable',
//         icon: 'dashboard',
//         children: [
//           {
//             id: 'analytics',
//             title: 'Analytics',
//             type: 'item',
//             url: '/analyticsdashboard'
//           },
//           {
//             id: 'project',
//             title: 'Project',
//             type: 'item',
//             url: '/projectdashboard'
//           }
//         ]
//       },
//       {
//         id: 'calendar',
//         title: 'Calendar',
//         type: 'item',
//         icon: 'today',
//         url: '/calendar',
//       },
//       {
//         id: 'todo',
//         title: 'To-Do',
//         type: 'item',
//         icon: 'today',
//         url: 'todo/all',
//       },
//       {
//         id: 'employees',
//         title: 'Employees',
//         type: 'item',
//         icon: 'account_box',
//         url: '/employees',
//       },
//       {
//         id: 'projects',
//         title: 'Projects',
//         type: 'item',
//         icon: 'library_books',
//         url: '/projects'
//       },
//       {
//         id: 'timesheet',
//         title: 'Timesheet',
//         type: 'item',
//         icon: 'restore',
//         url: '/timesheet',
//       },

//       {
//         id: 'clients',
//         title: 'Clients',
//         type: 'item',
//         icon: 'people_outline',
//         url: '/clients',
//       },
//       {
//         id: 'violations',
//         title: 'Violations',
//         type: 'item',
//         icon: 'report',
//         url: '/violations',
//       },
//       {
//         id: 'attendance',
//         title: 'Attendance',
//         type: 'item',
//         icon: 'library_books',
//         url: '/attendance',
//       },
//       {
//         id: 'scrumboard',
//         title: 'Scrumboard',
//         translate: 'NAV.SCRUMBOARD',
//         type: 'item',
//         icon: 'assessment',
//         url: 'scrumboard/boards'
//       }
//     ];
//     break;
//   case 'Leader':
//     navbar = [
//       // {
//       //   id: 'profile',
//       //   title: 'Profile',
//       //   type: 'item',
//       //   icon: 'person',
//       //   url: '/profile',
//       // },
//       {
//         id: 'dashboards',
//         title: 'Dashboards',
//         type: 'collapsable',
//         icon: 'dashboard',
//         children: [
//           {
//             id: 'analytics',
//             title: 'Analytics',
//             type: 'item',
//             url: '/analyticsdashboard'
//           },
//           {
//             id: 'project',
//             title: 'Project',
//             type: 'item',
//             url: '/projectdashboard'
//           }
//         ]
//       },
//       {
//         id: 'timesheet',
//         title: 'Timesheet',
//         type: 'item',
//         icon: 'restore',
//         url: '/timesheet',
//       },
//       {
//         id: 'violations',
//         title: 'Violations',
//         type: 'item',
//         icon: 'report',
//         url: '/violations',
//       },
//       {
//         id: 'calendar',
//         title: 'Calendar',
//         type: 'item',
//         icon: 'today',
//         url: '/calendar',
//       },
//       {
//         id: 'todo',
//         title: 'To-Do',
//         translate: 'NAV.TODO',
//         type: 'item',
//         icon: 'check_box',
//         url: 'todo/all',
//       },
//       {
//         id: 'scrumboard',
//         title: 'Scrumboard',
//         translate: 'NAV.SCRUMBOARD',
//         type: 'item',
//         icon: 'assessment',
//         url: 'scrumboard/boards'
//       }
//     ];

//   default:
//     navbar = [
//       // {
//       //   id: 'profile',
//       //   title: 'Profile',
//       //   type: 'item',
//       //   icon: 'person',
//       //   url: '/profile',
//       // },
//       {
//         id: 'dashboards',
//         title: 'Dashboards',
//         type: 'collapsable',
//         icon: 'dashboard',
//         children: [
//           {
//             id: 'analytics',
//             title: 'Analytics',
//             type: 'item',
//             url: '/analyticsdashboard'
//           },
//           {
//             id: 'project',
//             title: 'Project',
//             type: 'item',
//             url: '/projectdashboard'
//           }
//         ]
//       },
//       {
//         id: 'timesheet',
//         title: 'Timesheet',
//         type: 'item',
//         icon: 'restore',
//         url: '/timesheet',
//       },
//       {
//         id: 'violations',
//         title: 'Violations',
//         type: 'item',
//         icon: 'report',
//         url: '/violations',
//       },
//       {
//         id: 'calendar',
//         title: 'Calendar',
//         type: 'item',
//         icon: 'today',
//         url: '/calendar',
//       },
//       {
//         id: 'todo',
//         title: 'To-Do',
//         translate: 'NAV.TODO',
//         type: 'item',
//         icon: 'check_box',
//         url: 'todo/all',
//       },
//     ]

//     break;
// }

export const navigation: FuseNavigation[] = [];





